import { render, staticRenderFns } from "./SendMobileCard.html?vue&type=template&id=fc62b61a&scoped=true&"
import script from "./SendMobileCard.js?vue&type=script&lang=js&"
export * from "./SendMobileCard.js?vue&type=script&lang=js&"
import style0 from "./SendMobileCard.scss?vue&type=style&index=0&id=fc62b61a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc62b61a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VCol,VIcon,VTextField})
